var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProtection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.33 6.37002C27.3 6.11002 23.4 5.20002 19.5 3.90002C15.73 5.20002 11.83 6.11002 7.67 6.37002C7.02 6.50002 6.5 7.02002 6.5 7.67002V22.1C6.5 26 8.71 29.64 12.22 31.46L18.85 34.84C18.98 34.97 19.24 34.97 19.37 34.97C19.63 34.97 19.76 34.97 19.89 34.84L26.52 31.46C30.03 29.64 32.24 26.13 32.24 22.1V7.67002C32.5 7.02002 31.98 6.50002 31.33 6.37002ZM25.61 29.12L19.5 32.24V19.5H9.1V8.97002C12.61 8.58002 16.12 7.80002 19.5 6.76002V19.5H29.9V22.23C29.9 25.09 28.21 27.82 25.61 29.12Z",
    fill: "#8797EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtection);
export default __webpack_public_path__ + "static/media/protection.cf1a2208a863bfe5665696b68bb4582d.svg";
export { ForwardRef as ReactComponent };